<template>
  <v-card class="card">
    <v-card-actions>
      <v-btn 
        class="bg-red" 
        @click="close()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-title>Nuevo producto</v-card-title>
    <v-text-field
      v-model="productName"
      class="fg-blue"
      label="Nombre del producto"
      variant="outlined"
    />
    <v-text-field
      v-model="category"
      class="fg-blue"
      label="Categoría"
      variant="outlined"
    />
    <v-textarea
      v-model="description"
      class="fg-blue"
      label="Descripción"
      variant="outlined"
      rows="4"
      :counter="2000"
      maxlength="2000"
    />
    <v-text-field
      v-model="costs"
      type="number"
      class="fg-blue"
      label="Precio"
      variant="outlined"
    />
    <v-alert
      v-if="error"
      type="error"
      variant="tonal"
      density="comfortable"
      class="mb-3"
      closable
      @click:close="error = null"
    >
      {{ error }}
    </v-alert>

    <v-btn 
      class="bg-blue" 
      :loading="guardando"
      @click="saveProduct()"
    >
      <v-icon>mdi-save</v-icon>
      Guardar producto
    </v-btn>
  </v-card>
</template>
<script>
import apisProducts from '@/apis/apisProducts';
import { mensajeDeError } from '@/utils/errores';
/*
  alRegistrarCorrectamente(product)
  onClose
*/
export default {
  name: 'NewPorduct',
  props: { idCompany: 
    {
      type: Number,
      required: true
    } 
  },
  emits: ["alRegistrarCorrectamente", "onClose"],
  data: function(){
    return {
      company: "",
      productName: "",
      category: "",
      description: "",
      error: null,
      guardando: false,
      costs: ""
    }
  },
  methods: {
    saveProduct(){
      this.error = null;
      this.guardando = true;

      apisProducts.saveProduct(this.idCompany,this.productName,this.category,this.description,this.costs)
        .then( res => {
          this.$emit('alRegistrarCorrectamente', res);
          this.$emit("onClose")
        })
        // Sin este catch un fallo del servidor no producia nada visible: el
        // dialogo se quedaba abierto y parecia que el boton no respondia.
        .catch(error => {
          this.error = mensajeDeError(error, 'No se pudo guardar el producto');
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    close(){
      this.$emit("onClose")
    }
  }
}
</script>
<style scoped>
.card{
  padding: 20px;
}
</style>
